import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { TransactionResultReqParamsModel } from '../../models/transaction-result-models';

@Component({
  selector: 'app-payment-results-etisalat',
  templateUrl: './payment-results-etisalat.component.html',
  styleUrls: ['./payment-results-etisalat.component.scss']
})
export class PaymentResultsEtisalatComponent implements OnInit {

  public cardType!: string;
  public mdStatus!: string;
  public ErrMsg!: string;
  public amount!: string;
  public mdErrorMsg!: string;
  public transactionResultReqParams!:TransactionResultReqParamsModel;

  constructor(
    private activatedRoute: ActivatedRoute,
    private toastr: ToastrService,
    private translate: TranslateService,
    private router: Router,
    private location: Location
  ) {}

  ngOnInit(): void {
    if(JSON.parse(localStorage.getItem('tCompleteParams')!) && JSON.parse(localStorage.getItem('amount')!)){
      this.transactionResultReqParams = JSON.parse(localStorage.getItem('tCompleteParams')!);
      this.amount = localStorage.getItem('amount')!;  
    }else{
      this.translate.get('CARDOPERATIONS_QUERY_ALIAS_TRY_AGAIN').subscribe(translation => {
        this.toastr.error(translation);
      })
      this.location.replaceState('home');
      window.location.reload();
    }
  }

}
